import EditWidgetDialog from './EditWidgetDialog';
export default EditWidgetDialog;



// WEBPACK FOOTER //
// ./src/components/WidgetMenu/components/EditWidgetDialog/index.js